import { useAuthContext } from '../../providers/AuthContext';
import useQuery from '../../hooks/useQuery';
import { useEffect, useRef } from 'react';

const SocialLogin: React.FC = () => {
  const query = useQuery();

  const { socialLoginInit, socialLogin } = useAuthContext();
  const exchangingRef = useRef(false);

  const socialLoginLinkHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
    const provider = e.currentTarget.getAttribute('data-provider');
    if (provider) {
      try {
        await socialLoginInit(provider);
      } catch (err) {
        console.error('Social login error:', err);
        alert('Social login error: ' + (err as Error).message);
      }
    }
  };

  useEffect(() => {
    if (!query.get('code')) return;
    if (window.location.href.indexOf('code=') === -1) return;
    if (exchangingRef.current) return;
    exchangingRef.current = true;

    const currentUrl = window.location.href;
    console.log('SocialLogin: exchanging code, socialLogin fn:', socialLogin.toString().substring(0, 80));
    console.log('SocialLogin: URL with code:', currentUrl);
    socialLogin(currentUrl).then(() => {
      console.log('SocialLogin: exchange succeeded');
      window.history.replaceState({}, document.title, window.location.pathname);
    }).catch((err: any) => {
      console.error('SocialLogin exchange failed:', err);
    });
  }, [query.get('code')]);

  return (
    <div className="flex flex-col gap-3">
      <button
        type="button"
        onClick={socialLoginLinkHandler}
        data-provider="google_oauth2"
        aria-label="Continue with Google"
        className="flex items-center justify-center gap-3 w-full px-4 py-3 rounded-xl border border-border bg-card text-foreground text-sm font-medium hover:bg-muted/50 active:scale-[0.98] transition-all duration-200"
      >
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21.35 11.1H12.18V13.83H18.69C18.36 17.64 15.19 19.27 12.19 19.27C8.36 19.27 5.00 16.25 5.00 12.00C5.00 7.9 8.2 4.73 12.2 4.73C15.29 4.73 17.1 6.7 17.1 6.7L19 4.72C19 4.72 16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12C2.03 17.05 6.16 22 12.25 22C17.6 22 21.5 18.33 21.5 12.91C21.5 11.76 21.35 11.1 21.35 11.1Z" />
        </svg>
        Continue with Google
      </button>
      <button
        type="button"
        onClick={(e) => { console.log('FB CLICK FIRED, socialLoginInit:', typeof socialLoginInit, socialLoginInit.toString().substring(0, 100)); socialLoginLinkHandler(e); }}
        data-provider="facebook"
        aria-label="Continue with Facebook"
        className="flex items-center justify-center gap-3 w-full px-4 py-3 rounded-xl border border-border bg-card text-foreground text-sm font-medium hover:bg-muted/50 active:scale-[0.98] transition-all duration-200"
      >
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" />
        </svg>
        Continue with Facebook
      </button>
    </div>
  );
};

export default SocialLogin;
